import React from 'react';

const LoginBtn = ({ onLoginBtnClick }) => {

    const handleClickLoginBtn = () => {
        document.getElementById('betslip-container').style.display = 'inherit';
        document.getElementById("divBetSlipNormal").style.left = "calc(100vw - 90vw)";
        document.getElementById("betslip-over-lay").style.left = "0";
        document.body.style.overflow = "hidden";
        const element = document.querySelector('.bottom-menu');
        element.style.zIndex = '-1'
    };

    return <div role='button' tabIndex='0' className="login-icon" onClick={onLoginBtnClick || handleClickLoginBtn} />;
};
export default LoginBtn;
